import { render } from "./NLPDataListEditDialog.vue?vue&type=template&id=045e986a&scoped=true"
import script from "./NLPDataListEditDialog.vue?vue&type=script&lang=js"
export * from "./NLPDataListEditDialog.vue?vue&type=script&lang=js"

import "./NLPDataListEditDialog.vue?vue&type=style&index=0&id=045e986a&lang=scss&scoped=true"
import "./NLPDataListEditDialog.vue?vue&type=style&index=1&id=045e986a&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-045e986a"]])

export default __exports__